export default __webpack_public_path__ + "static/feature-1-8bb11fcc904c66c9c9038731df6cf202.png";